import api from '@/utils/axios';

/** Keep the API error code (e.g. `validation.name_duplicate`) for inline form errors. */
async function postManage(action, payload, fallbackMessage) {
  try {
    const response = await api.post('positions/manage', { action, ...payload });
    if (!response.data?.success) {
      const error = new Error(response.data?.error?.message || fallbackMessage);
      error.code = response.data?.error?.code || null;
      throw error;
    }
    return response.data.data;
  } catch (err) {
    if (err instanceof Error && err.message && !err.error) {
      throw err;
    }
    const error = new Error(
      err?.response?.data?.error?.message || err?.message || fallbackMessage
    );
    error.code = err?.response?.data?.error?.code || err?.code || null;
    throw error;
  }
}

export const fetchPositions = async ({
  page = 1,
  limit = 10,
  search = '',
  department_id = null,
  sortField = 'name',
  sortOrder = 'ASC',
  include_inactive = 0,
} = {}) => {
  const response = await api.post('positions/get', {
    page,
    limit,
    search,
    department_id,
    sortField,
    sortOrder,
    include_inactive: include_inactive ? 1 : 0,
  });

  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch positions');
  }

  const data = response.data.data || {};
  return {
    positions: Array.isArray(data.positions) ? data.positions : [],
    total: Number(data.total || 0),
    page: Number(data.page || page),
    limit: Number(data.limit || limit),
    summary: data.summary || null,
  };
};

export const createPosition = (payload) =>
  postManage('create', payload, 'Failed to create position');

/** Local search in Settings needs the complete reference list, not its first page. */
export async function fetchAllPositions(options = {}) {
  const positions = [];
  let page = 1;
  let total = Infinity;
  while (positions.length < total) {
    const result = await fetchPositions({ ...options, page, limit: 200 });
    positions.push(...result.positions);
    total = result.total;
    if (!result.positions.length) break;
    page += 1;
  }
  return positions;
}

export const updatePosition = (payload) =>
  postManage('update', payload, 'Failed to update position');

export const updatePositionStatus = ({ position_id, is_active }) =>
  postManage(
    'update_status',
    { position_id, is_active: is_active ? 1 : 0 },
    'Failed to update position status'
  );

export const deletePosition = ({ position_id }) =>
  postManage('delete', { position_id }, 'Failed to delete position');
